var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"text-center text-md",attrs:{"to":{ name: _vm.url }}},[_c('p',{staticClass:"block leading-none m-0",domProps:{"innerHTML":_vm._s(_vm.label)}})])}
var staticRenderFns = []

export { render, staticRenderFns }